import ColorSwatch from './ColorSwatch';
import ImageSwatch from './ImageSwatch';
import TextSwatch from './TextSwatch';
import type { SwatchRendererType } from './shared/types';

export default function SwatchRenderer(props: SwatchRendererType) {
    const {
        displayType,
        colors,
        image,
        name,
        unavailable,
        isSelected,
        linkAction,
        size = 'lg',
        onClick,
        ...restProps
    } = props;

    switch (displayType) {
        case 'Color':
            return (
                <ColorSwatch
                    colors={colors}
                    fallbackImage={image}
                    unavailable={unavailable}
                    isSelected={isSelected}
                    name={name}
                    linkAction={onClick ? undefined : linkAction}
                    size={size}
                    onClick={onClick}
                    {...restProps}
                />
            );
        case 'Image':
            return (
                <ImageSwatch
                    image={image}
                    name={name}
                    unavailable={unavailable}
                    isSelected={isSelected}
                    linkAction={onClick ? undefined : linkAction}
                    onClick={onClick}
                    {...restProps}
                />
            );
        case 'Text':
            return (
                <TextSwatch
                    name={name}
                    unavailable={unavailable}
                    isSelected={isSelected}
                    linkAction={onClick ? undefined : linkAction}
                    size={size}
                    onClick={onClick}
                    {...restProps}
                />
            );
        default:
            throw new Error(`"${displayType}" is not recognized as a valid type`);
    }
}
